import { Button } from "@sellar-io/components";
import { Alert } from "../../../../components/alert/Alert";
import { DialogContent, DialogCTA } from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { usePaymentMethodDeleteMany } from "../../../../hooks/api/v2/paymentMethod/usePaymentMethodDeleteMany";

export const PaymentMethodDeleteSubmitContent = ({
  selectedPaymentMethodIds,
  onDismiss,
}: {
  onDismiss: () => void;
  selectedPaymentMethodIds: number[] | undefined;
}) => {
  const deleteManyMutation = usePaymentMethodDeleteMany();
  const onSubmit = () => {
    console.log(selectedPaymentMethodIds);
    if (!selectedPaymentMethodIds) return;
    return deleteManyMutation.mutate(
      {
        ids: selectedPaymentMethodIds,
      },
      {
        onSuccess: () => onDismiss(),
      },
    );
  };
  return (
    <>
      <DialogContent>
        {deleteManyMutation.isError ? (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(deleteManyMutation.error)?.response?.data
                .message ?? "Unknown error"
            }
          />
        ) : null}
      </DialogContent>
      <DialogCTA>
        <Button
          color={"red"}
          loading={deleteManyMutation.isPending}
          onClick={onSubmit}
        >
          Remove
        </Button>
      </DialogCTA>
    </>
  );
};
